import {Vue, Component} from 'vue-property-decorator';
import { Observer } from "mobx-vue";

import CustomerIframe from '@/components/CustomerIframe';
import Navigation from '@/components/Navigation';
import Log from '@/components/Log';

import GlobalStore from '@/store/GlobalStore';

@Observer
@Component
export default class Customer extends Vue {
  
  constructor(props: any) {
    super(props)
  }
  
  state = {
    GlobalStore
  }
  
  async mounted () {
    await this.state.GlobalStore.getCustomerInfo()
  }
  
  
  render() {
    return (
      <div>
        <Navigation title='在线客服' />
        <CustomerIframe url={this.state.GlobalStore.customerInfo.url} />
        <Log type='hooks' number='A091' />
        <Log type='quit' number='A093' />
      </div>
    )
  }
  
}